export default __webpack_public_path__ + "static/media/security.dc832294.svg";